import { useCallback, useState } from 'react';

import { cartStore } from '../../store/cartStore';
import { CartItem } from '../CartItem/CartItem';
import styles from './CartItemsList.module.scss';

import type { CartItemModel } from '@/entities/cart/model/CartItemModel';
import { observer } from '@/shared/lib/signal/observer';
import { uiStore } from '@/shared/stores/uiStore';
import { Button } from '@/shared/ui-kit/Button/Button';
import { Icon } from '@/shared/ui-kit/Icon';
import { Modal } from '@/shared/ui-kit/Modal/Modal';
import { useToast } from '@/shared/ui-kit/ToastProvider/useToast';

const CartItemsListBase: React.FC = () => {
  const list: CartItemModel[] = cartStore.items.value;
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { showError } = useToast();

  const openConfirm = useCallback(() => setConfirmOpen(true), []);
  const closeConfirm = useCallback(() => setConfirmOpen(false), []);

  const handleConfirm = useCallback(async () => {
    try {
      await cartStore.clear();
      setConfirmOpen(false);
      uiStore?.closeCart?.();
    } catch (e) {
      console.error(e);
      showError?.('Не удалось очистить корзину');
      setConfirmOpen(false);
    }
  }, [showError]);

  if (!list?.length) return <div className={styles.empty}>Корзина пуста</div>;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>Корзина</h1>
        <Icon
          onClick={openConfirm}
          name="outlinedTrash"
          width={20}
          height={20}
          className={styles.icon}
        />
      </div>

      <div className={styles.list}>
        {list.map((it) => (
          <CartItem key={it.id} item={it} />
        ))}

        <Modal
          open={confirmOpen}
          onClose={closeConfirm}
          hideHeader
          fullScreen={false}
          className={styles.modal}
          closable={false}
        >
          <p className={styles.modalText}>Очистить корзину?</p>

          <div className={styles.modalActions}>
            <Button className={styles.cancelButton} onClick={closeConfirm}>
              Не очищать
            </Button>
            <Button className={styles.clearButton} onClick={handleConfirm}>
              Очистить
            </Button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export const CartItemsList = observer(CartItemsListBase);
